import { router } from 'expo-router';
import { SafeAreaView, StyleSheet, View } from 'react-native';

import { Button, IconChevronLeft, LogoSvg, tokens } from '@fhs/ui';

import { AuthHeader } from '../auth-header';

import { AuthContainerProps } from '.';

export function AuthContainerMobile({ children, hasBackNavigation }: AuthContainerProps) {
  return (
    <SafeAreaView>
      <AuthHeader backgroundHeight={60} imageHeight={250} />
      <View style={styles.container}>
        <View>
          <LogoSvg style={styles.logo} />
        </View>
        <View style={styles.content}>{children}</View>
      </View>
      {hasBackNavigation && (
        <Button
          type="ghost"
          style={styles.iconButton}
          onPress={() => {
            router.back();
          }}
        >
          <Button.Icon color={tokens.colors.$blackOpacity75} size={24}>
            <IconChevronLeft />
          </Button.Icon>
        </Button>
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    alignSelf: 'center',
    alignItems: 'center',
    marginVertical: 0,
    width: '85%',
    height: 1000,
    paddingHorizontal: 16,
    paddingVertical: 32,
    position: 'relative',
  },
  content: {
    marginVertical: 32,
  },
  iconButton: {
    position: 'absolute',
    marginHorizontal: 16,
    marginVertical: 12,
  },
  logo: { alignSelf: 'center', top: -60, position: 'absolute' },
});
